import { render } from "./StockReserveds.vue?vue&type=template&id=5e705c7b&scoped=true"
import script from "./StockReserveds.vue?vue&type=script&lang=js"
export * from "./StockReserveds.vue?vue&type=script&lang=js"

import "./StockReserveds.vue?vue&type=style&index=0&id=5e705c7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e705c7b"]])

export default __exports__